export interface Reason {
  text: string;
  amznKey: string;
  reasonCode: string;
}

// used in actions/account/returns.js
export const EMPTY_REASON: Reason = {
  text: 'Select a reason',
  amznKey: '',
  reasonCode: ''
};

export const UNHAPPY_WITH_STYLE: Reason = {
  text: 'Unhappy with style / item',
  amznKey: 'AMZ-PG-APP-STYLE',
  reasonCode: '203'
};

const FOUND_BETTER_PRICE: Reason = {
  text: 'Found better price',
  amznKey: 'CR-FOUND_BETTER_PRICE',
  reasonCode: '2'
};

const ARRIVED_TOO_LATE: Reason = {
  text: 'Arrived late',
  amznKey: 'TA-CR-ARRIVED_TOO_LATE',
  reasonCode: '1010'
};

const DAMAGED_DURING_TRANSIT: Reason = {
  text: 'Damaged packaging',
  amznKey: 'CR-DAMAGED_BY_CARRIER',
  reasonCode: '14'
};

const MISSING_ITEM: Reason = {
  text: 'Item or part of item missing',
  amznKey: 'CR-MISSING_ITEM_IN_SET',
  reasonCode: '1015'
};

const WRONG_MERCHANDISE: Reason = {
  text: 'Wrong item was sent',
  amznKey: 'CR-SWITCHEROO',
  reasonCode: '15'
};

const CR_UNWANTED_ITEM: Reason = {
  text: 'No longer needed',
  amznKey: 'CR-UNWANTED_ITEM',
  reasonCode: '18'
};
const AMZ_PG_APP_TOO_SMALL: Reason = {
  text: 'Too small',
  amznKey: 'AMZ-PG-APP-TOO-SMALL',
  reasonCode: '201'
};
const AMZ_PG_APP_TOO_LARGE: Reason = {
  text: 'Too large',
  amznKey: 'AMZ-PG-APP-TOO-LARGE',
  reasonCode: '202'
};
const AMZ_PG_BAD_DESC: Reason = {
  text: 'Does not match description',
  amznKey: 'AMZ-PG-BAD-DESC',
  reasonCode: '205'
};
const CR_QUALITY_UNACCEPTABLE: Reason = {
  text: 'Product condition unacceptable',
  amznKey: 'CR-QUALITY_UNACCEPTABLE',
  reasonCode: '4'
};
const CR_DAMAGED_BY_FC: Reason = {
  text: 'Original brand box missing',
  amznKey: 'CR-DAMAGED_BY_FC',
  reasonCode: '6'
};

export const RETURN_REASONS: Reason[] = [
  EMPTY_REASON,
  CR_UNWANTED_ITEM,
  AMZ_PG_APP_TOO_SMALL,
  AMZ_PG_APP_TOO_LARGE,
  UNHAPPY_WITH_STYLE,
  FOUND_BETTER_PRICE,
  WRONG_MERCHANDISE,
  AMZ_PG_BAD_DESC,
  CR_QUALITY_UNACCEPTABLE,
  CR_DAMAGED_BY_FC,
  MISSING_ITEM,
  DAMAGED_DURING_TRANSIT,
  ARRIVED_TOO_LATE
];

export const RETURN_REASONS_HAVE_NOT_BEEN_SELECTED_ERROR = 'RETURN_REASONS_HAVE_NOT_BEEN_SELECTED_ERROR';
export const RETURN_REASON_REQUIRES_CUSTOMER_SERVICE_ERROR = 'RETURN_REASON_REQUIRES_CUSTOMER_SERVICE_ERROR';
export const RETURN_REASON_MISSING_ACCEPT_TERMS_OF_RETURN_ERROR = 'RETURN_REASON_MISSING_ACCEPT_TERMS_OF_RETURN_ERROR';
